import { Tooltip } from "react-migration/components/Tooltip";
import { Theme } from "react-migration/lib/theme/Theme";

export const EnvironmentalPermitsInfoTooltip = () => (
  <Tooltip.Wrapper>
    <Tooltip.Content size="sm" side="bottom" align="end" theme={Theme.Light}>
      <Tooltip.Description>
        <p className="my-2 text-xs font-normal">
          All Environmental Resource Permits submitted in the last 2 years from Florida’s five Water Management
          Districts.
        </p>
      </Tooltip.Description>
    </Tooltip.Content>
    <Tooltip.Trigger>
      <i className="icon-lt-information-line text-text-base-secondary-a print:hidden" />
    </Tooltip.Trigger>
  </Tooltip.Wrapper>
);
